'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../_base');

var _base2 = _interopRequireDefault(_base);

var _DayPickerInput = require('react-day-picker/DayPickerInput');

var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);

require('react-day-picker/lib/style.css');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('./date.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//https://github.com/gpbl/react-day-picker
//http://react-day-picker.js.org/docs/


// import this after the css above so we can overwrite it


var GeckoFieldDate = function (_GeckoFieldBase) {
	_inherits(GeckoFieldDate, _GeckoFieldBase);

	function GeckoFieldDate() {
		_classCallCheck(this, GeckoFieldDate);

		return _possibleConstructorReturn(this, (GeckoFieldDate.__proto__ || Object.getPrototypeOf(GeckoFieldDate)).apply(this, arguments));
	}

	_createClass(GeckoFieldDate, [{
		key: 'displayFormat',
		value: function displayFormat() {
			return this.field().display_format || 'YYYY/MM/DD';
		}
	}, {
		key: 'format',
		value: function format() {
			return this.field().format || 'YYYY/MM/DD';
		}
	}, {
		key: 'prepareValue',
		value: function prepareValue(value) {
			return (0, _moment2.default)(value).format(this.format());
		}
	}, {
		key: 'handleChange',
		value: function handleChange(value) {
			return this.props.handler.bind(this, this.field().key, this.prepareValue(value))();
		}
	}, {
		key: 'value',
		value: function value() {
			// get nested object values from a key like 'nested.object.value' to target {nested: {object: {value: 'test'}}}
			var keyFragments = this.field().key.split('.');
			var getValue = function getValue(obj, key) {
				return obj[key];
			};
			var value = keyFragments.reduce(getValue, this.props.values);
			var parsed = (0, _moment2.default)(value, this.format()).format(this.displayFormat());
			return parsed !== 'Invalid date' ? parsed : '';
		}
	}, {
		key: 'render',
		value: function render() {
			var dayPickerProps = {
				todayButton: 'Go to Today',
				enableOutsideDays: true,
				modifiers: {
					monday: { daysOfWeek: [1] }
				}
			};

			return _react2.default.createElement(_DayPickerInput2.default, {
				id: this.renderId(),
				'aria-label': this.renderAriaLabel(),
				className: 'col-sm form-control gecko-ui-material',
				value: this.value(),
				onDayChange: this.handleChange.bind(this),
				format: this.displayFormat(),
				placeholder: this.field().placeholder,
				dayPickerProps: dayPickerProps,
				disabled: this.isDisabled()
			});
		}
	}]);

	return GeckoFieldDate;
}(_base2.default);

exports.default = GeckoFieldDate;
